"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ActionItemMeeting () {
        return ActionItemMeeting;
    },
    get ActionItemModel () {
        return ActionItemModel;
    },
    get ActionItemParticipant () {
        return ActionItemParticipant;
    },
    get ActionItemWithMeetingInfo () {
        return ActionItemWithMeetingInfo;
    },
    get CreateMeetingActionItemServiceActionSchema () {
        return CreateMeetingActionItemServiceActionSchema;
    },
    get GetActionItemsSearchParams () {
        return GetActionItemsSearchParams;
    },
    get GetActionItemsSearchResponse () {
        return GetActionItemsSearchResponse;
    },
    get UpdateMeetingActionItemServiceActionSchema () {
        return UpdateMeetingActionItemServiceActionSchema;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("./base");
const ActionItemMeeting = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId,
    status: _models.MeetingActionItemStatusSchema
});
const ActionItemParticipant = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    role: _models.MeetingActionItemRoleSchema,
    name: _zod.z.string().optional()
});
const ActionItemModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    meetings: _zod.z.array(ActionItemMeeting),
    participants: _zod.z.array(ActionItemParticipant),
    dueDate: _utilsisomorphic.transformDate.or(_zod.z.null()),
    created: _base.UserActionRecord,
    updated: _base.UserActionRecord
});
const CreateMeetingActionItemServiceActionSchema = _models.MeetingActionItemsSchema.pick({
    name: true,
    meetings: true,
    participants: true,
    due_date: true
});
const UpdateMeetingActionItemServiceActionSchema = _models.MeetingActionItemsSchema.pick({
    name: true,
    meetings: true,
    participants: true,
    due_date: true,
    updated: true
}).partial();
const ActionItemWithMeetingInfo = ActionItemModel.extend({
    mostRecentMeetingId: _utilsisomorphic.transformObjectId,
    mostRecentMeetingStartDateTime: _utilsisomorphic.transformDate,
    mostRecentMeetingStatus: _models.MeetingActionItemStatusSchema,
    workspaceId: _utilsisomorphic.transformObjectId,
    workspaceName: _zod.z.string()
});
const GetActionItemsSearchParams = _zod.z.object({
    name: _zod.z.string().optional(),
    created_by_user_id: _zod.z.string().optional(),
    assignee_user_id: _zod.z.string().optional(),
    is_unassigned: _zod.z.string().optional(),
    status: _zod.z.string().optional(),
    due_date_start: _zod.z.string().optional(),
    due_date_end: _zod.z.string().optional(),
    workspace_id: _zod.z.string().optional(),
    page: _zod.z.string().optional(),
    limit: _zod.z.string().optional(),
    sort: _zod.z.string().optional()
});
const GetActionItemsSearchResponse = _zod.z.object({
    results: _zod.z.array(ActionItemWithMeetingInfo),
    total: _zod.z.number()
});
